export const iconFontAwesomeShapesFile = (
	<i className="fa-solid fa-file"></i>
);
